export const KeyCodes = Object.freeze({
  SPACE: "Space",
  SPACE_LITERAL: " ",
  ENTER: "Enter",
  ARROW_UP: "ArrowUp",
  ARROW_DOWN: "ArrowDown",
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  PAGE_UP: "PageUp",
  PAGE_DOWN: "PageDown",
  TAB: "Tab",
  ESCAPE: "Escape",
  HOME: "Home",
  END: "End",
  BACKSPACE: "Backspace",
  DELETE: "Delete",
  SHIFT_LEFT: "ShiftLeft",
  SHIFT_RIGHT: "ShiftRight",
  CONTROL_LEFT: "ControlLeft",
  CONTROL_RIGHT: "ControlRight",
  ALT_LEFT: "AltLeft",
  ALT_RIGHT: "AltRight",
  META_LEFT: "MetaLeft",
  META_RIGHT: "MetaRight",
});
